var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.4H14.6C16.2 7.4 17 6.6 17 5V3.4C17 1.8 16.2 1 14.6 1H13C11.4 1 10.6 1.8 10.6 3.4V5C10.6 6.6 11.4 7.4 13 7.4ZM3.4 17H5C6.6 17 7.4 16.2 7.4 14.6V13C7.4 11.4 6.6 10.6 5 10.6H3.4C1.8 10.6 1 11.4 1 13V14.6C1 16.2 1.8 17 3.4 17ZM4.2 7.4C5.04869 7.4 5.86263 7.06286 6.46274 6.46274C7.06286 5.86263 7.4 5.04869 7.4 4.2C7.4 3.35131 7.06286 2.53737 6.46274 1.93726C5.86263 1.33714 5.04869 1 4.2 1C3.35131 1 2.53737 1.33714 1.93726 1.93726C1.33714 2.53737 1 3.35131 1 4.2C1 5.04869 1.33714 5.86263 1.93726 6.46274C2.53737 7.06286 3.35131 7.4 4.2 7.4ZM13.8 17C14.6487 17 15.4626 16.6629 16.0627 16.0627C16.6629 15.4626 17 14.6487 17 13.8C17 12.9513 16.6629 12.1374 16.0627 11.5373C15.4626 10.9371 14.6487 10.6 13.8 10.6C12.9513 10.6 12.1374 10.9371 11.5373 11.5373C10.9371 12.1374 10.6 12.9513 10.6 13.8C10.6 14.6487 10.9371 15.4626 11.5373 16.0627C12.1374 16.6629 12.9513 17 13.8 17Z",
    stroke: "#2E732F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnSettings);
export default __webpack_public_path__ + "static/media/ColumnSettings.a3b9dda1b181b1934a2e95d3f8662dac.svg";
export { ForwardRef as ReactComponent };